/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Translator } from '../../../core/i18n/translator';

const Tag = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font: normal normal normal 16px/60px Source Sans Pro;
  color: #424242;
  border-radius: 15px;

  background: ${(props) => props.bgColor || '#FFC4001A'} 0% 0% no-repeat
    padding-box;
  border: 1px solid ${(props) => props.borderColor || '#F8AC00'};

  min-width: 112px;
  width: auto;
  height: 25px;
  margin-right: 0px;
  padding: 0px 5px;
`;

function TagStatus({ label, status }) {
  const [colorTagBg, setColorTagBg] = useState('');
  const [colorTagBorder, setColorTagBorder] = useState('');

  const dicionario = [
    { status: 'Resolvido', boderColor: '#00C691', bgColor: '#00C6911A' },
    { status: 'Aprovado', boderColor: '#00C691', bgColor: '#00C6911A' },
    { status: 'Coletado pela transportadora', boderColor: '#F5EA80', bgColor: '#FFC4001A' },
    { status: 'Enviado', boderColor: '#F5EA80', bgColor: '#FFC4001A' },
    { status: 'Pendente', boderColor: '#F8AC00', bgColor: '#FFC4001A' },
    { status: 'Esperando seleção do local de devolução', boderColor: '#F8AC00', bgColor: '#FFC4001A' },
    { status: 'Rejeitado', boderColor: '#e61c1c', bgColor: '#ff00031a' },
  ];

  useEffect(() => {
    const currStatus = dicionario.find((item) => item.status === status);
    if (currStatus) {
      setColorTagBg(currStatus.bgColor);
      setColorTagBorder(currStatus.boderColor);
    }
  }, [label, status]);

  return (
    <Tag status={status} bgColor={colorTagBg} borderColor={colorTagBorder}>
      {Translator(`order.status.${label}`)}
    </Tag>
  );
}

export default TagStatus;
TagStatus.defaultProps = {
  label: '',
  status: '',
};
TagStatus.propTypes = {
  label: PropTypes.string,
  status: PropTypes.string,
};
